const isIOSDevice = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

const openSMS = (url) => {
  window.location.href = url;
};

// Note: Android doesn't support multi-recipient SMS, only the first number will be used
const sendSMS = (inputNumbers, body) => {
  // Validate and normalize input numbers
  if (!inputNumbers) return;

  const numbers = (
    Array.isArray(inputNumbers) ? inputNumbers : [inputNumbers]
  ).filter(Boolean);

  if (!numbers.length) return;

  // Determine device and recipient count
  const isIOS = isIOSDevice();
  const isSingleRecipient = numbers.length === 1;
  const isMultiRecipient = !isSingleRecipient && isIOS; // Android doesn't support multi-recipient

  // Build SMS URL
  let smsUrl;

  if (isMultiRecipient) {
    // iOS multi-recipient format
    smsUrl = `sms://open?addresses=${numbers.join(',')}`;
    if (body) {
      smsUrl += `&body=${encodeURIComponent(body)}`;
    }
  } else {
    // Single recipient (or Android multi-recipient fallback to first number)
    smsUrl = `sms:${numbers[0]}`;
    if (body) {
      const separator = isIOS ? '&' : '?';
      smsUrl += `${separator}body=${encodeURIComponent(body)}`;
    }
  }

  openSMS(smsUrl);
};

export { sendSMS };
